/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}


$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});

/**
 * Popup de vídeo flutuante na página do produto (Ramon - 08/09/2026).
 * A bolha só aparece quando o produto tem o campo "Vídeo popup" (metafield
 * custom.video_popup) preenchido no admin. Ao clicar, abre um popup central
 * com o vídeo (YouTube, Vimeo ou link direto de arquivo .mp4). O vídeo só é
 * carregado quando o cliente clica, para não pesar a página por padrão.
 */
(function () {
  function getEmbedHtml(src) {
    var ytMatch = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{11})/);
    if (ytMatch) {
      return '<iframe src="https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&playsinline=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    }

    var vimeoMatch = src.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
    if (vimeoMatch) {
      return '<iframe src="https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    }

    return '<video src="' + src + '" controls autoplay playsinline></video>';
  }

  function init() {
    var bubble = document.getElementById('vip-video-bubble');
    var modal = document.getElementById('vip-video-modal');
    if (!bubble || !modal || bubble.dataset.vipBound) return;
    bubble.dataset.vipBound = 'true';

    var content = document.getElementById('vip-video-modal-content');

    function openModal() {
      content.innerHTML = getEmbedHtml(bubble.dataset.videoSrc);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      content.innerHTML = ''; // para o vídeo ao fechar
      document.body.style.overflow = '';
    }

    bubble.addEventListener('click', openModal);
    bubble.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal();
      }
    });

    Array.prototype.forEach.call(modal.querySelectorAll('[data-action="vip-close-video"]'), function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();

/**
 * Preview na bolha do vídeo (Ramon - 01/10/2026).
 * A bolha passa a mostrar o próprio vídeo rodando em miniatura (sem som, em
 * loop), estilo "Stories", para chamar a atenção do cliente:
 * - Link direto de vídeo (ex.: Arquivos da Shopify, .mp4): mostra o vídeo
 *   rodando dentro da bolha.
 * - YouTube: mostra a capa (thumbnail) do vídeo.
 * - Vimeo ou formato desconhecido: mantém a bolha escura com o ícone de play.
 * O preview pausa enquanto o popup está aberto e volta ao fechar.
 */
(function () {
  var STYLE_ID = 'vip-video-preview-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = '' +
      '.vip-video-bubble.has-preview{width:76px;height:76px;padding:3px;overflow:visible;' +
        'background:linear-gradient(45deg,#c9a24d,#f3e2b3,#c9a24d);}' +
      '.vip-video-bubble.has-preview .vip-video-bubble__media{position:absolute;inset:3px;' +
        'border-radius:50%;overflow:hidden;background:#1c1b1b;border:2px solid #fff;}' +
      '.vip-video-bubble.has-preview .vip-video-bubble__media video,' +
      '.vip-video-bubble.has-preview .vip-video-bubble__media img{width:100%;height:100%;' +
        'object-fit:cover;display:block;pointer-events:none;}' +
      '.vip-video-bubble.has-preview > svg{position:absolute;right:-2px;bottom:-2px;z-index:2;' +
        'width:24px;height:24px;margin:0;padding:6px 5px 6px 7px;box-sizing:border-box;' +
        'border-radius:50%;background:#1c1b1b;border:2px solid #fff;fill:#fff;}' +
      '@media screen and (max-width:640px){' +
        '.vip-video-bubble.has-preview{width:66px;height:66px;}' +
        '.vip-video-bubble.has-preview > svg{width:22px;height:22px;}' +
      '}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function buildPreview(src) {
    var yt = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{11})/);
    if (yt) {
      var img = document.createElement('img');
      img.src = 'https://i.ytimg.com/vi/' + yt[1] + '/hqdefault.jpg';
      img.alt = '';
      img.loading = 'lazy';
      return img;
    }

    if (/vimeo\.com\//.test(src)) return null;

    var video = document.createElement('video');
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('aria-hidden', 'true');
    video.src = src;
    return video;
  }

  function init() {
    var bubble = document.getElementById('vip-video-bubble');
    var modal = document.getElementById('vip-video-modal');
    if (!bubble || bubble.dataset.vipPreview) return;
    bubble.dataset.vipPreview = 'true';

    var media = buildPreview(bubble.dataset.videoSrc || '');
    if (!media) return;

    injectStyle();

    var wrap = document.createElement('span');
    wrap.className = 'vip-video-bubble__media';
    wrap.appendChild(media);
    bubble.insertBefore(wrap, bubble.firstChild);
    bubble.classList.add('has-preview');

    // Se o vídeo/imagem não carregar, volta para a bolha original com o play.
    media.addEventListener('error', function () {
      bubble.classList.remove('has-preview');
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    });

    if (media.tagName !== 'VIDEO') return;

    function tryPlay() {
      var p = media.play();
      if (p && p.catch) p.catch(function () {});
    }
    tryPlay();

    // Pausa o preview enquanto o popup está aberto, volta ao fechar.
    if (modal && window.MutationObserver) {
      new MutationObserver(function () {
        if (modal.classList.contains('is-open')) media.pause();
        else tryPlay();
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    }

    // Economiza bateria: pausa quando a aba fica em segundo plano.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) media.pause();
      else if (!modal || !modal.classList.contains('is-open')) tryPlay();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();